import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Cluster } from '../../clusters/cluster.interface';

export class ClusterService {
   async getClusters(tenantId: number, query?: LocationQuery): Promise<ApiResource<Cluster>> {
      const response = await http.get<ApiResource<Cluster>>(`/tenants/${tenantId}/clusters`, { params: { ...query } });
      return response.data;
   }

   async get() {
      throw Error('Method not implemented');
   }

   async postCluster(tenantId: number, cluster: Cluster) {
      const response = await http.post<ApiResource<Cluster>>(`/tenants/${tenantId}/clusters`, cluster);
      return response.data;
   }

   async putCluster(tenantId: number, clusterId: number, cluster: Cluster) {
      const response = await http.put<ApiResource<Cluster>>(`/tenants/${tenantId}/clusters/${clusterId}`, cluster);
      return response.data;
   }

   async deleteCluster(tenantId: number, clusterId: number) {
      const response = await http.delete(`/tenants/${tenantId}/clusters/${clusterId}`);
      return response.data;
   }
}
